import React, { forwardRef } from 'react';
import { clsx, createUseStyles, multiply } from '@pushpay/styles';
import { Button, LARGE_BUTTON_HEIGHT_RATIO, LARGE_BUTTON_SPACING_RATIO, createButtonStateStyles } from './button';
import { getButtonColor } from './button-color';
export const useStyles = createUseStyles(theme => {
  const buttonColor = getButtonColor(theme);
  return {
    root: {
      font: theme.TYPOGRAPHY.BUTTONS,
      width: multiply('1em', LARGE_BUTTON_HEIGHT_RATIO),
      height: multiply('1em', LARGE_BUTTON_HEIGHT_RATIO),
      padding: 0,
      justifyContent: 'center',
      borderRadius: `calc(${LARGE_BUTTON_HEIGHT_RATIO / 2} * 1em)`,
      color: theme.colors['color-text-default'],
      whiteSpace: 'nowrap',
      '& :not(:last-child)': {
        marginRight: `calc(1em * ${LARGE_BUTTON_SPACING_RATIO})`
      },
      '& svg': {
        width: '1.25em',
        height: '1.25em'
      }
    },
    primary: {
      borderWidth: '1px',
      borderStyle: 'solid',
      ...createButtonStateStyles(buttonColor.ACTION)
    },
    secondary: { ...createButtonStateStyles(buttonColor.TERTIARY)
    },
    disabled: {},
    icon: {},

    /**
     * Should only be used for testing
     * @deprecated should only be used for testing
     */
    __hover: {},

    /**
     * Should only to be used for testing
     * @deprecated should only be used for testing
     */
    __active: {}
  };
});
export const ActionButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    icon: IconComponent,
    children,
    classes: classesProp,
    disabled,
    className: classNameProp,
    'data-pp-at-target': targetId,
    displayStyle = 'primary',
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp, classes[displayStyle], {
    [classes.disabled]: disabled
  });
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    className: className,
    displayStyle: "unstyled",
    disabled: disabled,
    type: "button",
    "data-pp-at-target": targetId
  }, rest), IconComponent && /*#__PURE__*/React.createElement(IconComponent, {
    className: classes.icon,
    "data-pp-at-target": `${targetId}-icon`
  }), children);
});